function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// 2024-08-15 Google 新增 LoAF  128.0.6613.86
// https://developer.chrome.com/docs/web-platform/long-animation-frames?hl=zh-cn#long-tasks-shortcomings

import { observe } from "../../../utils/web-vitals/lib/observe";
import { sendAsyncMetric } from '.';
import { fix2Int } from "../../utils";

// const loafQueue = []

// TODO： 提供 loaf 能力
export function startLongAnimationFrame(taskRef) {
  var _PerformanceObserver;
  var _ref = taskRef.value,
    ctx = _ref.ctx;
  var _ref2 = ctx.options || {},
    _ref2$loafDurationThr = _ref2.loafDurationThreshold,
    loafDurationThreshold = _ref2$loafDurationThr === void 0 ? 200 : _ref2$loafDurationThr;
  // console.log('startLongAnimationFrame taskRef',  taskRef)

  var entryHandler = function entryHandler(entries) {
    // console.log('long-animation-frame', entries)
    if (!entries.length) return;
    var _iterator = _createForOfIteratorHelper(entries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        // console.log('long-animation-frame', entry)
        var name = entry.name;
        var startTime = fix2Int(entry.startTime);
        var duration = fix2Int(entry.duration);
        if (duration < loafDurationThreshold) return;
        var endTime = fix2Int(startTime + duration);
        var scripts = entry.scripts || [];
        var script = '';
        if (scripts.length) {
          var _iterator2 = _createForOfIteratorHelper(scripts),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var s = _step2.value;
              var sTime = fix2Int(s.startTime);
              var _duration = fix2Int(s.duration);
              var eTime = fix2Int(sTime + _duration);
              var invoker = (s.invoker || '').replaceAll('-', '_');
              var invokerType = (s.invokerType || 'null').replaceAll('-', '_');
              var sFName = (s.sourceFunctionName || 'null').replaceAll('-', '_');
              var sCPosition = fix2Int(s.sourceCharPosition || 0);
              var source = (s.sourceURL || 'null').replaceAll('-', '_');
              script += "".concat(script ? '--' : '').concat(s.name, "-").concat(sTime, "-").concat(_duration, "-").concat(eTime, "-").concat(source, "-").concat(invokerType, "-").concat(invoker, "-").concat(sFName, "-").concat(sCPosition);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        var loaf = {
          name: name,
          timestamp: Date.now(),
          startTime: startTime,
          endTime: endTime,
          duration: duration,
          script: script
        };
        var value = "".concat(loaf.timestamp, "|").concat(loaf.name, "|").concat(loaf.startTime, "|").concat(loaf.duration, "|").concat(loaf.endTime, "|").concat(loaf.script);
        sendAsyncMetric(taskRef.value, {
          type: 'loaf',
          value: value
        });
      }

      // const allScripts = entries.flatMap(entry => entry?.scripts);
      // const scriptSource = [...new Set(allScripts.map(script => script.sourceURL))];
      // const scriptsBySource = scriptSource.map(sourceURL => ([sourceURL,
      //   allScripts.filter(script => script.sourceURL === sourceURL)
      // ]));
      // // 
      // const processedScripts = scriptsBySource.map(([sourceURL, scripts]) => ({
      //   sourceURL,
      //   count: scripts.length,
      //   totalDuration: scripts.reduce((subtotal, script) => subtotal + script.duration, 0)
      // }));
      // processedScripts.sort((a, b) => b.totalDuration - a.totalDuration);
      // // TODO 收集 loaf
      // loafQueue.push(...processedScripts)
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  if ((_PerformanceObserver = PerformanceObserver) !== null && _PerformanceObserver !== void 0 && (_PerformanceObserver = _PerformanceObserver.supportedEntryTypes) !== null && _PerformanceObserver !== void 0 && _PerformanceObserver.includes('long-animation-frame')) {
    observe('long-animation-frame', entryHandler);
  }
}